// extracted by mini-css-extract-plugin
export var container = "style-module--container--a3a8b";
export var detail = "style-module--detail--0c74b";
export var heading = "style-module--heading--d52e6";